import { GenerateProcess } from "redux-process";
import { getCompanyID } from "../../selectors";

export const sendCompanyTaxAddressUpdate =
	({ companyCode, addressLine1, addressLine2, zipCode, hasTaxExclusion }) =>
	(dispatch, getState) => {
		// parse state
		const state = getState();
		const companyId = getCompanyID(state);

		// request
		dispatch(
			GenerateProcess("UpdateCompanyTaxAddress", {
				companyId,
				payload: { companyCode, addressLine1, addressLine2, zipCode, hasTaxExclusion },
			})
		);
	};

export const displayValidationError = (message) => (dispatch) => {
	dispatch({
		type: "NOTIFICATION:ERROR",
		message,
		actionMessage: "Dismiss",
	});
};
